import React, {
  createContext,
  useRef,
  useState,
  useEffect
} from "react"

export const DivContext = createContext()

export const DivProvider = ({ children }) => {
  const [currentLocation, setCurrentLocation] = useState("/")
  const [formStep, setFormStep] = useState(0)

  const formStepsRef = useRef(null)
  const [openMenuMobile, setOpenMobile] = useState(false)

  const [counterSteps, setCounterSteps] = useState(0)

  const iframeRef = useRef(null)

  const goStepForm = () => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)
      const step = urlParams.get("paso")
      setFormStep(step - 1)
    }
  }

  useEffect(() => {
    if (window.location.href.includes("paso")) {
      goStepForm()
    }
  }, [])

  useEffect(() => {
    setCounterSteps(c => c + 1)
  }, [formStep])

  const [classOpenMenuMobile, setClassOpenMenuMobile] = useState("")
  useEffect(() => {
    let txt = openMenuMobile ? "active" : ""
    setClassOpenMenuMobile(txt)
  }, [openMenuMobile])

  return (
    <DivContext.Provider
      value={{
        currentLocation,
        setCurrentLocation,
        formStep,
        setFormStep,
        formStepsRef,
        openMenuMobile,
        setOpenMobile,
        classOpenMenuMobile,
        iframeRef,
        counterSteps,
        setCounterSteps,
      }}
    >
      {children}
    </DivContext.Provider>
  )
}
